// 對應 CustomizeModel.FormType的列舉
export class BuyOrRentType {
  static get Buy () {
    return 1
  }
  static get Rent () {
    return 2
  }
  static get Try () {
    return 3
  }

  static BuyOrRentTypeName (BuyOrRentType) {
    let tmpType = parseInt(BuyOrRentType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '買斷'
        break
      case 2:
        name = '公司提供'
        break
      case 3:
        name = '試裝'
        break
    }
    return name
  }
}
